export enum DeactivationType {
  ALREADY_FOUND_SOMEONE,
  DONT_LIKE_POTENTIAL_MATCHES_FOR_ME,
  NO_ONE_IN_MY_AREA,
  NOT_ABLE_TO_PAY,
  NOT_INTERESTED_IN_ONLINE_DATING,
  PROBLEMS_WITH_THE_WEBSITE,
  THE_PRICE_FOR_THE_SERVICE_IS_TOO_HIGH,
  TOO_MANY_EMAILS,
  TOO_MANY_NOTIFICATIONS,
  OTHER
}

export const DeactivateReasonList = [
  {id: DeactivationType.ALREADY_FOUND_SOMEONE, label: 'Already found someone'},
  {id: DeactivationType.DONT_LIKE_POTENTIAL_MATCHES_FOR_ME, label: 'Don\'t like potential matches for me'},
  {id: DeactivationType.NO_ONE_IN_MY_AREA, label: 'No one in my area'},
  {id: DeactivationType.NOT_ABLE_TO_PAY, label: 'Not able to pay'},
  {id: DeactivationType.NOT_INTERESTED_IN_ONLINE_DATING, label: 'Not interested in online dating'},
  {id: DeactivationType.PROBLEMS_WITH_THE_WEBSITE, label: 'Problems with the website'},
  {id: DeactivationType.THE_PRICE_FOR_THE_SERVICE_IS_TOO_HIGH, label: 'The price for the service is too high'},
  {id: DeactivationType.TOO_MANY_EMAILS, label: 'Too many emails'},
  {id: DeactivationType.TOO_MANY_NOTIFICATIONS, label: 'Too many notifications'},
  {id: DeactivationType.OTHER, label: 'Other'}
]